export default function (Component) {
            Component.options.skeletonTemplate = "\n\n\n\n\n<div class=\"skeleton\">&nbsp;</div>\n"
        }